import './style.scss';

import Navigate from '../../components/Navigate';

//const root = document.querySelector(':root');
const dark = 'dark.svg';
const light = 'sun.svg';
let themeIcon;
let container;
let html;
let theme = 'dark';


function Header() {
  document.body.style='background-color: var(--bs-dark);transition: 0.5s;';
 
  return (
    <header id="accueil">

      <div className="theme-container shadow-dark mode" onClick={setTheme}>
        <img
          id="theme-icon"
          src={light}
          alt="button dark mode"
        />
      </div>


      <div className="containerLogoHeader">
        <img alt="logo mdm development" src='https://res.cloudinary.com/dst61tkcz/image/upload/v1658826239/mdm-devlopment/logo-site-header_ipmiqs.webp' className="logoHeader" />
      </div>
      <div className="containerTxt">
        <Navigate />
      </div>
   
    </header>
  );
}
export default Header;



function setTheme() {
  themeIcon = document.querySelector('#theme-icon');
  container = document.querySelector('.theme-container');
  html = document.querySelector('html');
  switch (theme) {
    case 'dark':
      setLight();
      theme = 'light';
      break;
    case 'light':
      setDark();
      theme = 'dark';
      break;
  }
}
function setLight() {
 
  container.classList.remove('shadow-dark');
  html.classList.remove('dark');
  setTimeout(() => {
    container.classList.add('shadow-light');
    html.classList.add('light');
    themeIcon.classList.remove('change');
  }, 300);
  themeIcon.classList.add('change');
  themeIcon.src = dark;
}
function setDark() {
  //root.style.setProperty('--bs-dark', '#212529');
  container.classList.remove('shadow-light');
  html.classList.remove('light');
  setTimeout(() => {
    container.classList.add('shadow-dark');
    html.classList.add('dark');
    themeIcon.classList.remove('change');
  }, 300);
  themeIcon.classList.add('change');
  themeIcon.src = light;
}